module.exports = __webpack_public_path__ + "img/Certificate.74ffc6ce.svg";